import React, { useState} from 'react';
import Header from '../header/Header.js';
import Footer from '../footer/Footer.js';
import * as AuthConstants from '../../data/AuthConstants.js';
import './Login.css'
import { Auth } from 'aws-amplify';
//import './Spinner.css'
import logo from '../../img/ue-login.png';

function Login() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    Auth.configure({
        oauth: {
            ...Auth.configure().oauth,
            redirectSignIn: window.location.origin + '/home',
            redirectSignOut: window.location.origin + '/',
            clientId: AuthConstants.AUTH_CLIENT_ID,
            responseType: AuthConstants.AUTH_CONFIG_RESPONSE_TYPE,
            scope: AuthConstants.AUTH_CONFIG_SCOPE
        },
    });

    const handleLogin = async () => {
        try {
            setLoading(true);

            // Autenticación federada con ADFS
            await Auth.federatedSignIn({ provider: 'UE-ADFS'});

        } catch (error) {
            setLoading(false);
            setError('No es posible iniciar sesión.');
            console.error(error);
        }
    };

    return (
        <div className='login-container'>
            <div className='circle'>
            </div>
            <Header />
            <img src={logo} alt="Logo" className='page-image' />
            <div className='content'>
                <div style={{ textAlign: 'center'}}>
                    <p style={{ fontSize: '30px', alignSelf: 'center', fontWeight: 'bold'}}>VISOR DE INFORMES</p>
                </div>
                <button className='button' type="button" onClick={handleLogin}>{loading ? 'Iniciando...' : 'Iniciar sesión en Universidad Europea'}</button>
            </div>
            <Footer />
        </div>
    );
}

export default Login;